import { useState } from "react";
import axios from "../axios";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (!/\d/.test(password)) {
      toast.error("Le mot de passe doit contenir au moins 1 chiffre.");
      return;
    }
    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas.");
      return;
    }
    try {
      await axios.post("/auth/reset-password", { token, password });
      navigate("/login?reset=1");
    } catch (err) {
      toast.error(err.response?.data?.error || "Lien invalide ou expiré.");
    }
  };

  const inputStyle = {
    width: "100%", padding: "12px 44px 12px 16px", borderRadius: "8px",
    border: "1.5px solid #e2e8f0", fontSize: "15px",
    outline: "none", boxSizing: "border-box"
  };

  const eyeStyle = {
    position: "absolute", right: "12px", top: "50%",
    transform: "translateY(-50%)", background: "none",
    border: "none", cursor: "pointer", color: "#94a3b8",
    fontSize: "18px", padding: "0"
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#f8fafc", padding: "24px"
    }}>
      <ToastContainer theme="colored" />
      <div style={{
        maxWidth: "400px", width: "100%", background: "white",
        borderRadius: "16px", padding: "32px",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)"
      }}>
        <h2 style={{ marginBottom: "8px", color: "#1e293b" }}>Nouveau mot de passe</h2>
        <p style={{ color: "#64748b", fontSize: "14px", marginBottom: "24px" }}>
          Choisissez un nouveau mot de passe pour votre compte.
        </p>
        <form onSubmit={handleSubmit}>
          <div style={{ position: "relative", marginBottom: "4px" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Nouveau mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={inputStyle}
            />
            <button type="button" onClick={() => setShowPassword(!showPassword)} style={eyeStyle}>
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
          <p style={{ fontSize: "11px", color: "#94a3b8", marginTop: "4px", marginBottom: "14px" }}>
            Minimum 8 caractères dont 1 chiffre
          </p>
          <div style={{ position: "relative", marginBottom: "20px" }}>
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirmer le mot de passe"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              style={inputStyle}
            />
            <button type="button" onClick={() => setShowConfirm(!showConfirm)} style={eyeStyle}>
              {showConfirm ? "🙈" : "👁️"}
            </button>
          </div>
          <button
            type="submit"
            style={{
              width: "100%", padding: "13px", background: "#e11d48",
              color: "white", border: "none", borderRadius: "8px",
              fontWeight: 700, fontSize: "15px", cursor: "pointer"
            }}
          >
            Modifier le mot de passe
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
